import React from "react";
import "./ListLecturersComponent.scss";
import { Form, Input } from "antd";
import CustomButton from "../AccommodationData/CustomButton/CustomButton";

function ListLecturersComponent(props: any) {
  let serverUrl = process.env.REACT_APP_API_URL;
  let storageUrl = serverUrl + "files/storage/";

  const handleChangeLecturer = (recturer: any) => {
    props.editLecturer(recturer);
  };

  return (
    <div className="all-recturers-card">
      {props.allLecturers?.map((recturer: any, i: number) => {
        return (
          <div className="card-r" key={i}>
            <div className="circle">
              <p>{recturer?.serialNumber}</p>
            </div>
            {recturer?.photo ? (
              <div
                className="image-r"
                style={{
                  backgroundImage: `url(${storageUrl}${recturer?.photo?.id})`,
                }}
              ></div>
            ) : (
              <div className="image-r"></div>
            )}

            <div className="personal-data-r">
              <Form.Item label="Ime">
                <Input
                  className="input-label"
                  placeholder="Unesite ime"
                  name="firstName"
                  value={recturer.firstName}
                />
              </Form.Item>
              <Form.Item label="Prezime">
                <Input
                  className="input-label"
                  placeholder="Unesite prezime"
                  name="lastName"
                  value={recturer.lastName}
                />
              </Form.Item>
            </div>
            <div className="bio-r">
              <label>Biografija:</label>
              <textarea value={recturer.biography} maxLength={10} />
            </div>
            <div className="footer-r">
              <CustomButton
                danger={false}
                htmlType={"submit"}
                type={""}
                function={() => {
                  handleChangeLecturer(recturer);
                }}
                text={"Izmeni"}
              />
              <CustomButton
                danger={false}
                htmlType={"submit"}
                type={""}
                function={() => {
                  props.deleteOneLecturer(recturer);
                }}
                text={"Izbriši"}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ListLecturersComponent;
